export const MERGE_TAG_ELEMENT = "merge-tag" as const;
